import { API } from 'api';
import { AxiosResponse } from 'axios';
import { IRegionsListRequest, IRegionsListResponse } from 'types';
import { API_URL } from 'utils/enums';

class RegionsService {
	static getRegions = async (reqBody: IRegionsListRequest): Promise<AxiosResponse<IRegionsListResponse>> =>
		API.post(API_URL.REGIONS_LIST, reqBody);
}

export { RegionsService };
